/*
 * CCH / GRH native product section
 * Pairs with sections/cch-product.liquid
 * - Variant picker (swatches + pills), price/SKU/barcode/availability updates
 * - Wholesale quantity multiples (custom.wsoldin)
 * - AJAX add to cart -> header count/total refresh -> ajaxCart drawer
 * - Scroll-snap media gallery with thumbs + lightbox
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || '${{amount}}';

    function delimit(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(match[0], value);
  }

  function rootUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path.replace(/^\//, '');
  }

  function decodeEntities(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str || '';
    return t.value;
  }

  /* Header cart count / total — same targets the old EComposer workaround used */
  function refreshHeader() {
    return fetch(rootUrl('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.getElementById('cart-count');
        var totalEl = document.getElementById('cart-total');
        if (countEl) countEl.textContent = cart.item_count;
        if (totalEl) {
          var moneyEl = totalEl.querySelector('.money') || totalEl;
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            moneyEl.innerHTML = window.Shopify.formatMoney(cart.total_price, window.general && window.general.currency);
          } else {
            moneyEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
          }
        }
        document.dispatchEvent(new CustomEvent('cch:cart-updated', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function (err) {
        console.warn('[cch-product] header refresh failed:', err);
      });
  }

  function openDrawer() {
    if (typeof window.ajaxCart !== 'undefined' && window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load(false, true, false, true);
      return true;
    }
    return false;
  }

  function CCHProduct(root) {
    this.root = root;
    this.form = document.getElementById(root.dataset.formId);
    if (!this.form) return;

    this.product = JSON.parse(root.querySelector('[data-cch-product-json]').textContent);
    this.extra = JSON.parse(root.querySelector('[data-cch-variant-extra]').textContent);
    this.moneyFormat = decodeEntities(root.dataset.moneyFormat);
    this.multiple = parseInt(root.dataset.qtyMultiple, 10) || 1;
    this.appManagesPrice = root.dataset.appPrice === 'true';
    this.afterAdd = root.dataset.afterAdd || 'drawer';
    this.idInput = this.form.querySelector('[data-cch-variant-id]');

    var currentId = parseInt(this.idInput.value, 10);
    this.variant = this.product.variants.find(function (v) { return v.id === currentId; }) || this.product.variants[0];

    this.initPicker();
    this.initQty();
    this.initForm();
    this.initGallery();
    this.initWishlist();
    this.updateQtyLimits();
    this.applyWholesalePrice();
  }

  /* ---------------- Wholesale All In One (Digital Coo) pricing ---------------- */
  // The app's own custom code only targets EComposer markup, so this section calls the app's
  // pricing function directly with our price element — on load and on every variant change.
  // Only runs when the app script is present and says the customer is wholesale.
  CCHProduct.prototype.applyWholesalePrice = function () {
    var self = this;
    var tries = 0;
    clearTimeout(this.wsTimer);

    function ready() {
      return typeof window.WSAIO !== 'undefined' && typeof window.WSAIO.productDiscount === 'function';
    }

    function run() {
      var WS = window.WSAIO;
      if (typeof WS.isWholesaleCustomer === 'function' && WS.isWholesaleCustomer() === false) return;
      var el = self.root.querySelector('[data-cch-price-current]');
      if (!el) return;
      var v = self.variant;
      // The app skips elements it has already priced (wsdapp), so clear that first.
      el.classList.remove('wsdapp', 'empty', 'wsnocompare');
      try {
        if (typeof WS.variantChange === 'function') WS.variantChange(self.product, v);
        WS.productDiscount({
          item_price_selector: el,
          template: 'product',
          product_id: self.product.id,
          product_handle: self.product.handle,
          variant_id: v.id,
          variant_sku: v.sku,
          variant_price: v.price,
          variant_compare_at_price: v.compare_at_price
        }, function (response) {
          var discounted = response && response.regular_discount && Number(response.regular_discount.ws_discount) > 0;
          self.root.classList.toggle('cch-has-wholesale-price', !!discounted);
          if (discounted) {
            // Retail sale badge / compare-at price don't apply to a wholesale price.
            self.root.querySelectorAll('[data-cch-sale-badge], [data-cch-price-compare]').forEach(function (b) { b.hidden = true; });
          }
          document.dispatchEvent(new CustomEvent('cch:wholesale-price', { detail: { variant: v, response: response } }));
        });
      } catch (err) {
        console.warn('[cch-product] wholesale price update failed:', err);
      }
    }

    (function wait() {
      if (ready()) return run();
      if (++tries > 40) return; // app not loaded (retail customer or app disabled) — give up after ~10s
      self.wsTimer = setTimeout(wait, 250);
    })();
  };

  /* Wishlist: the Notify Me app places its button inside the product form, which the section renders
     inside the Wishlist block. Nothing to do here — moving the app's button causes it to fight back. */
  CCHProduct.prototype.initWishlist = function () {};

  /* ---------------- Variant picker ---------------- */

  CCHProduct.prototype.initPicker = function () {
    var self = this;
    this.optionButtons = Array.prototype.slice.call(this.root.querySelectorAll('[data-cch-option-value]'));
    this.optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.selectOption(parseInt(btn.dataset.optionIndex, 10), btn.dataset.value);
      });
    });
    this.refreshOptionAvailability();
  };

  CCHProduct.prototype.findVariant = function (options) {
    return this.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === options[i]; });
    });
  };

  CCHProduct.prototype.selectOption = function (index, value) {
    var opts = this.variant.options.slice();
    opts[index] = value;
    var match = this.findVariant(opts);
    if (!match) {
      var vs = this.product.variants;
      match = vs.find(function (v) { return v.options[index] === value && v.available; }) ||
              vs.find(function (v) { return v.options[index] === value; });
    }
    if (match) this.setVariant(match);
  };

  CCHProduct.prototype.refreshOptionAvailability = function () {
    var self = this;
    var current = this.variant.options;
    this.optionButtons.forEach(function (btn) {
      var idx = parseInt(btn.dataset.optionIndex, 10);
      var val = btn.dataset.value;
      var test = current.slice();
      test[idx] = val;
      var exists = false;
      var available = self.product.variants.some(function (v) {
        var matches = v.options.every(function (o, i) { return o === test[i]; });
        if (matches) exists = true;
        return matches && v.available;
      });
      btn.classList.toggle('is-unavailable', !available);
      btn.classList.toggle('is-nonexistent', !exists);
      btn.setAttribute('aria-pressed', current[idx] === val ? 'true' : 'false');
    });
    this.root.querySelectorAll('[data-cch-option-selected]').forEach(function (el) {
      var i = parseInt(el.dataset.cchOptionSelected, 10);
      el.textContent = current[i] || '';
    });
  };

  CCHProduct.prototype.setVariant = function (variant) {
    if (!variant) return;
    this.variant = variant;

    this.idInput.value = variant.id;
    this.idInput.dispatchEvent(new Event('change', { bubbles: true }));

    this.refreshOptionAvailability();
    this.updatePrice();
    this.updateAvailability();
    this.updateAttributes();
    this.updateQtyLimits();
    this.applyWholesalePrice();

    if (variant.featured_media) this.goToMedia(variant.featured_media.id);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    document.dispatchEvent(new CustomEvent('cch:variant-change', {
      detail: { sectionId: this.root.dataset.sectionId, variant: variant, product: this.product }
    }));
  };

  CCHProduct.prototype.updatePrice = function () {
    var v = this.variant;
    var onSale = v.compare_at_price && v.compare_at_price > v.price;

    var cur = this.root.querySelector('[data-cch-price-current]');
    if (cur) {
      cur.setAttribute('data-variant-id', v.id);
      cur.setAttribute('data-price', v.price);
      cur.classList.toggle('cch-price__current--sale', !!onSale);
      if (!this.appManagesPrice) cur.innerHTML = '<span class="money">' + formatMoney(v.price, this.moneyFormat) + '</span>';
    }

    var cmp = this.root.querySelector('[data-cch-price-compare]');
    if (cmp) {
      cmp.hidden = !onSale;
      cmp.innerHTML = onSale ? formatMoney(v.compare_at_price, this.moneyFormat) : '';
    }

    var badge = this.root.querySelector('[data-cch-sale-badge]');
    if (badge) {
      var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      badge.textContent = (badge.dataset.template || '[percent]% OFF').replace('[percent]', pct);
      badge.hidden = !(onSale && v.available);
    }
  };

  CCHProduct.prototype.updateAvailability = function () {
    var v = this.variant;
    this.root.querySelectorAll('[data-cch-soldout-badge]').forEach(function (el) { el.hidden = v.available; });
    this.updateButton();

    this.root.querySelectorAll('[data-cch-notify]').forEach(function (notify) {
      if (notify.dataset.visibility === 'sold_out') notify.hidden = v.available;
    });
  };

  CCHProduct.prototype.updateButton = function () {
    var btn = this.root.querySelector('[data-cch-atc]');
    if (!btn) return;
    var text = btn.querySelector('[data-cch-atc-text]');
    var available = this.variant.available;
    btn.disabled = !available;
    if (text) text.textContent = available ? btn.dataset.textAdd : btn.dataset.textSoldOut;
    if (btn.dataset.hideSoldOut === 'true') btn.hidden = !available;
  };

  CCHProduct.prototype.updateAttributes = function () {
    var extra = this.extra[String(this.variant.id)] || {};
    var sku = this.root.querySelector('[data-cch-sku]');
    var barcode = this.root.querySelector('[data-cch-barcode]');
    if (sku) sku.textContent = extra.sku || this.variant.sku || 'N/A';
    if (barcode) barcode.textContent = extra.barcode || this.variant.barcode || 'N/A';
  };

  /* ---------------- Quantity (wholesale multiples) ---------------- */

  CCHProduct.prototype.initQty = function () {
    var self = this;
    this.qty = this.root.querySelector('[data-cch-qty]');
    if (!this.qty) return;

    var minus = this.root.querySelector('[data-cch-qty-minus]');
    var plus = this.root.querySelector('[data-cch-qty-plus]');

    if (minus) minus.addEventListener('click', function () {
      self.setQty((parseInt(self.qty.value, 10) || self.multiple) - self.multiple);
    });
    if (plus) plus.addEventListener('click', function () {
      self.setQty((parseInt(self.qty.value, 10) || 0) + self.multiple);
    });
    this.qty.addEventListener('change', function () { self.setQty(self.qty.value); });
    this.qty.addEventListener('blur', function () { self.setQty(self.qty.value); });
  };

  CCHProduct.prototype.getMaxQty = function () {
    var e = this.extra[String(this.variant.id)] || {};
    var max = 9999;
    if (e.mgmt && e.policy !== 'continue' && e.inv > 0) max = e.inv;
    if (e.ruleMax && e.ruleMax < max) max = e.ruleMax;
    return max;
  };

  CCHProduct.prototype.snap = function (val) {
    var m = this.multiple;
    val = parseInt(val, 10) || m;
    if (val < m) val = m;
    var rem = val % m;
    if (rem !== 0) val = val + (m - rem);
    var max = this.getMaxQty();
    if (val > max) {
      var capped = Math.floor(max / m) * m;
      val = capped >= m ? capped : m;
    }
    return val;
  };

  CCHProduct.prototype.setQty = function (val) {
    if (!this.qty) return;
    this.qty.value = this.snap(val);
  };

  CCHProduct.prototype.updateQtyLimits = function () {
    if (!this.qty) return;
    var m = this.multiple;
    var max = this.getMaxQty();
    var cappedMax = Math.max(m, Math.floor(max / m) * m);
    this.qty.setAttribute('min', m);
    this.qty.setAttribute('step', m);
    this.qty.setAttribute('max', cappedMax);
    this.setQty(this.qty.value);
  };

  /* ---------------- Add to cart ---------------- */

  CCHProduct.prototype.initForm = function () {
    var self = this;
    // Capture phase on window so the theme's own ajaxCart submit handler never sees this form (prevents double-adds).
    window.addEventListener('submit', function (e) {
      if (e.target !== self.form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      self.addToCart();
    }, true);
  };

  CCHProduct.prototype.showMessage = function (text, isError) {
    var msg = this.root.querySelector('[data-cch-atc-message]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle('is-error', !!isError);
    msg.hidden = false;
    clearTimeout(this.msgTimer);
    if (!isError) {
      this.msgTimer = setTimeout(function () { msg.hidden = true; }, 4000);
    }
  };

  CCHProduct.prototype.addToCart = function () {
    var self = this;
    if (this.busy || !this.variant.available) return;
    this.busy = true;

    if (this.qty) this.setQty(this.qty.value);

    var btn = this.root.querySelector('[data-cch-atc]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }

    var body = new FormData(this.form);
    if (!body.get('quantity')) body.set('quantity', String(this.multiple));

    fetch(rootUrl('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart.');
        document.dispatchEvent(new CustomEvent('cch:cart-added', { detail: { item: res.data } }));

        if (self.afterAdd === 'cart') {
          window.location.href = self.root.dataset.cartUrl || rootUrl('cart');
          return;
        }
        return refreshHeader().then(function () {
          var opened = self.afterAdd === 'drawer' && openDrawer();
          if (!opened) self.showMessage((btn && btn.dataset.textAdded) || 'Added to cart', false);
        });
      })
      .catch(function (err) {
        self.showMessage(err.message, true);
      })
      .then(function () {
        self.busy = false;
        if (btn) btn.classList.remove('is-loading');
        self.updateButton();
      });
  };

  /* ---------------- Gallery ---------------- */

  CCHProduct.prototype.initGallery = function () {
    var self = this;
    this.viewport = this.root.querySelector('[data-cch-viewport]');
    if (!this.viewport) return;
    this.slides = Array.prototype.slice.call(this.viewport.children);
    this.thumbs = Array.prototype.slice.call(this.root.querySelectorAll('[data-cch-thumb]'));

    var prev = this.root.querySelector('[data-cch-prev]');
    var next = this.root.querySelector('[data-cch-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(self.currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.currentIndex() + 1); });

    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.goTo(parseInt(t.dataset.cchThumb, 10)); });
    });

    var ticking = false;
    this.viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        self.setActiveThumb(self.currentIndex());
        ticking = false;
      });
    }, { passive: true });

    // Lightbox
    var dialog = this.root.querySelector('[data-cch-lightbox]');
    var dialogImg = this.root.querySelector('[data-cch-lightbox-img]');
    if (dialog && dialogImg && typeof dialog.showModal === 'function') {
      this.root.querySelectorAll('[data-cch-zoom]').forEach(function (z) {
        z.addEventListener('click', function () {
          var img = z.querySelector('img');
          dialogImg.src = z.dataset.cchZoom;
          dialogImg.alt = img ? img.alt : '';
          dialog.showModal();
        });
      });
      var close = function () { dialog.close(); dialogImg.src = ''; };
      var closeBtn = this.root.querySelector('[data-cch-lightbox-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);
      dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target === dialogImg) close(); });
    }

    // Start on the selected variant's image if the URL had ?variant=
    if (this.variant && this.variant.featured_media) this.goToMedia(this.variant.featured_media.id, true);
  };

  CCHProduct.prototype.currentIndex = function () {
    if (!this.viewport || !this.viewport.clientWidth) return 0;
    return Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
  };

  CCHProduct.prototype.goTo = function (index, instant) {
    if (!this.slides || !this.slides.length) return;
    var count = this.slides.length;
    index = ((index % count) + count) % count;
    this.viewport.scrollTo({ left: this.slides[index].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    this.setActiveThumb(index);
    this.pauseMedia(index);
  };

  CCHProduct.prototype.goToMedia = function (mediaId, instant) {
    if (!this.slides) return;
    var idx = this.slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
    if (idx > -1) this.goTo(idx, instant);
  };

  CCHProduct.prototype.setActiveThumb = function (index) {
    if (!this.thumbs) return;
    // Thumbnails are a static grid — only the highlight moves, nothing scrolls or hides.
    this.thumbs.forEach(function (t, i) {
      var active = i === index;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-current', active ? 'true' : 'false');
    });
  };

  CCHProduct.prototype.pauseMedia = function (activeIndex) {
    this.slides.forEach(function (s, i) {
      if (i === activeIndex) return;
      s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      s.querySelectorAll('iframe').forEach(function (f) {
        try {
          f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          f.contentWindow.postMessage('{"method":"pause"}', '*');
        } catch (e) { /* cross-origin */ }
      });
    });
  };

  /* ---------------- Boot ---------------- */

  function init(scope) {
    (scope || document).querySelectorAll('[data-cch-product]').forEach(function (el) {
      if (!el.__cchProduct) el.__cchProduct = new CCHProduct(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.CCHProduct = CCHProduct;
})();
